import { render, staticRenderFns } from "./StartBreakModal.vue?vue&type=template&id=438d1bf8&scoped=true"
import script from "./StartBreakModal.vue?vue&type=script&lang=js"
export * from "./StartBreakModal.vue?vue&type=script&lang=js"
import style0 from "./StartBreakModal.vue?vue&type=style&index=0&id=438d1bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d1bf8",
  null
  
)

export default component.exports